module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[101]466.c2ff042.woff2";